import Vue from 'vue'
import router from './router/index'
// import VueAxios from 'vue-axios'
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)

import { Lazyload } from 'vant'
Vue.use(Lazyload, {
  error: '/statics/images/nav_e.png',
  loading: '/statics/images/loading.gif'
})

// 各API接口
import api from './api/api' // 导入api接口
// 首页模板
import App from './components/page/App.vue'
// 状态管理
import store from './vuex/store'

// 全局参数
const publicData = {
	errImg: process.env.BASE_URL + "statics/images/nav_e.png", // 图片加载失败图
    loadImg: process.env.BASE_URL + "statics/images/loading.gif", // 图片加载中图片
    uploadImage: "", // 上传图片的url
    clientUrl: "http://health.shidaijiyi.com", //客户端跳转url
    wsuri: "wss://health.shidaijiyi.com:9506/", // 正式直播接收信息
    imgPath: "http://health.shidaijiyi.com", // 正式
    domain: "http://health.shidaijiyi.com", // 正式 图片路径  注: 分享时也使用了它,分享图片需要拼全路径
    // clientUrl: 'http://192.168.3.88:8080/m/#',
    // clientUrl: "https://tmall-new.shanmuzhi.com/#",
    // wsuri: "wss://tmall-new.shanmuzhi.com:9506/", // 测试直播接收信息
    // imgPath: "https://timemap2_laravel.shanmuzhi.com/", // 测试
    // domain: "http://timemap2_laravel.shanmuzhi.com", // 测试 图片路径
    locationDefault: {
        // 默认定位 北京
        lng: 116.397777,
        lat: 39.909206,
    },
    intangibleDefault:
        process.env.BASE_URL + "statics/images/default_goods.png", // 商品默认图片
    defaultTouxiang:
        process.env.BASE_URL + "statics/images/default_touxiang.png", // 头像默认图片
    defalutFengmian:
        process.env.BASE_URL + "statics/images/default_fengmian.png", // 封面默认图片
    logo: process.env.BASE_URL + "statics/images/default_touxiang.png",
    headLineTouxiang: process.env.BASE_URL + "statics/images/my/icon_logo.png", // 头条头像
}

Vue.prototype.$publicData = publicData;

Vue.config.productionTip = false
Vue.prototype.$api = api // 将api挂载到vue的原型上
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
